import type { BodyRouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type InviteProgramBody = {
  program: {
    /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
    community_ids: string[];
    organization_ids: string[];
    user_ids: string[];
    /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
  };
};

type InviteProgramRouteParams = {
  programId: string;
};

export const inviteProgram = async ({
  body,
  routeParams: { programId },
}: BodyRouteParamsRequest<InviteProgramBody, InviteProgramRouteParams>) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.program.invite(programId), body);
